export const latinFonts = [
  {
    className: 'poppins',
    fontFamily: 'Poppins',
    fontWeight: 500,
  },
  {
    className: 'opensans',
    fontFamily: 'Open Sans',
    fontWeight: 400,
  },
  {
    className: 'montserrat',
    fontFamily: 'Montserrat',
    fontWeight: 400,
  },
  {
    className: 'quicksand',
    fontFamily: 'Quicksand',
    fontWeight: 400,
  },
  {
    className: 'cabin',
    fontFamily: 'Cabin',
    fontWeight: 400,
  },
  {
    className: 'averiasanslibre',
    fontFamily: 'Averia Sans Libre',
    fontWeight: 400,
  },
  {
    className: 'acme',
    fontFamily: 'Acme',
    fontWeight: 400,
  },
  {
    className: 'dosis',
    fontFamily: 'Dosis',
    fontWeight: 400,
  },
  {
    className: 'librebaskerville',
    fontFamily: 'Libre Baskerville',
    fontWeight: 400,
  },
  {
    className: 'playfairdisplay',
    fontFamily: 'Playfair Display',
    fontWeight: 400,
  },
  {
    className: 'rocksalt',
    fontFamily: 'Rock Salt',
    fontWeight: 400,
  },
  {
    className: 'merienda',
    fontFamily: 'Merienda',
    fontWeight: 400,
  },
  {
    className: 'kalam',
    fontFamily: 'Kalam',
    fontWeight: 400,
  },
  {
    className: 'specialelite',
    fontFamily: 'Special Elite',
    fontWeight: 400,
  },
  {
    className: 'oswald',
    fontFamily: 'Oswald',
    fontWeight: 400,
  },
  {
    className: 'londrinasolid',
    fontFamily: 'Londrina Solid',
    fontWeight: 400,
  },
  {
    className: 'prostoone',
    fontFamily: 'Prosto One',
    fontWeight: 400,
  },
  {
    className: 'fredokaone',
    fontFamily: 'Fredoka One',
    fontWeight: 400,
  },
  {
    className: 'righteous',
    fontFamily: 'Righteous',
    fontWeight: 400,
  },
  {
    className: 'rokkitt',
    fontFamily: 'Rokkitt',
    fontWeight: 400,
  },
  {
    className: 'novaround',
    fontFamily: 'Nova Round',
    fontWeight: 400,
  },
  {
    className: 'architectsdaughter',
    fontFamily: 'Architects Daughter',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'lobstertwo',
    fontFamily: 'Lobster Two',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'gochihand',
    fontFamily: 'Gochi Hand',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'anton',
    fontFamily: 'Anton',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'monofett',
    fontFamily: 'Monofett',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'frederickathegreat',
    fontFamily: 'Fredericka the Great',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'berkshireswash',
    fontFamily: 'Berkshire Swash',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'racingsansone',
    fontFamily: 'Racing Sans One',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'secularone',
    fontFamily: 'Secular One',
    fontWeight: 400,
    pro: true,
  },
  {
    className: 'barrio',
    fontFamily: 'Barrio',
    fontWeight: 400,
    pro: true,
  },
];
